import type { TournamentPlayer } from '../../generated/prisma';

export type InnPlayerRef = Pick<TournamentPlayer, 'playerId'>;

/** 0-based index of `playerId` in `players`, or null if absent. */
export function getInnTournamentPlayerIndex(
  players: readonly InnPlayerRef[],
  playerId: string
): number | null {
  const i = players.findIndex((p) => p.playerId === playerId);
  return i === -1 ? null : i;
}

/** 1-based ladder rank (index + 1), or null if absent. */
export function getInnLadderRank(
  players: readonly InnPlayerRef[],
  playerId: string
): number | null {
  const ix = getInnTournamentPlayerIndex(players, playerId);
  return ix === null ? null : ix + 1;
}
